<template>
  <v-theme-provider :dark="dark">
    <div>
      <base-title
        size="body-1"
        space="4"
        title="Established in 1995, Jo-An Recruitment & Consultancy Services is licensed and approved by the Ministry of Manpower Singapore. We are experienced in a broad range of placements (headhunting, local, foreign domestic workers, foreign workers, caregivers, nurses placements etc) and own a training centre in Indonesia."
        weight="regular"
      />

      <p class="Lic">LIC NO: 95C8957</p>
      <base-btn class="mb-12" color="white" outlined href="/privacy-policy">
        Privacy Policy
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
export default {
  name: "BaseInfo",

  props: {
    title: String,
    dark: Boolean,
  },

  data: () => ({
    business: [
      {
        icon: "mdi-map-marker-outline",
        title: "Address",
        text: "810 Geylang Rd, #03-145D City Plaza, Singapore 409286",
      },
      {
        icon: "mdi-cellphone",
        title: "Phone",
        text: " 66107758 / 66107026 +65-89209748",
      },
      {
        icon: "mdi-email",
        title: "Email",
        text: "contact@JoanRecruit.com <br> www.JoanRecruit.com",
      },
      {
        icon: "mdi-clock",
        title: "Time",
        text: "Monday - Sunday 11am to 8pm (please make an appointment)",
      },
    ],
  }),
};
</script>

<style scoped>
.logo-filter {
  filter: white (100%);
}
.Lic {
  color: rgb(255, 255, 255);
}
</style>
